<template>
  <div class="pt-2 pb-4 d-flex align-center justify-center">
    <button type="button" class="text-grey" @click="$emit('click')">
      {{ $t('COMMON.BUTTON.LOAD_MORE') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LoadMoreButton',
  emits: ['click']
}
</script>
